import React from 'react';
import "../../../../styles/enroll.scss"
import { ChevronDown, ChevronUp, Upload, CreditCard, Wallet, Building2, FileText, Eye, AlertCircle, CheckCircle, Loader2, Gavel, SaudiRiyal } from 'lucide-react';
import i18n from '../../../../i18n';
import { getLoggedUser } from '../../../../state/user';
import swal from "sweetalert";
import { checkBlackList } from "../../../../models/blacklist";
import { enrollUser, getAuction } from "../../../../models/auctions";
import { getUserInfo, getUserStatus } from "../../../../models/users";
import { createThawaniCustomer, createThawaniSession } from "../../../../models/thawani";
import {
    thawaniPaymentUrl,
    thawaniConfig,
    paymentSuccessUrl,
    paymentCancelledUrl,
} from "../../../../constants/global";
import { HomeBanner } from '../../homeBanner';
import { ProfileUpdateSection } from '../../../helpers/ProfileUpdateSection';
import { createPayment } from './services/EnrollService';
import { WalletFund } from '../../../helpers/walletFund';


const user = getLoggedUser();
let lng = localStorage.getItem("I18N_LANGUAGE");

const USER_FIELDS = {
    file_id_number: i18n.t("attach_id_no"),
    authority_name: i18n.t("auth_name"),
    account_number: i18n.t("account_number"),
    cr_number: i18n.t("cr_number"),
    resident_card_number: i18n.t("personal_card_no"),
    vat_number: i18n.t("vat_number"),
    file_cr_number: i18n.t("attacth_cr_copy"),
    file_auth_letter: i18n.t("auth_letter"),
    file_vat_certificate: i18n.t("attach_vat"),
};

export default class Enroll extends React.Component {
    constructor() {
        super();
        let path = window.location.pathname;
        let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);
        this.state = {
            online_type: "local",
            show_terms_panel: false,
            show_bank_panel: false,
            ptype: "offline",
            input: { ...user },
            is_company: false,
            t_c_accept: false,
            payment: {},
            auction: auctionId,
            is_payment: false,
            civilCard: null,
            crFile: null,
            bankGuaranteeFile: null,
            bankAccountFile: null,
            signature: null,
            is_payment_loading: false,
            is_loading: false,
            show_success_message: false,
            terms: "",
            is_online_payment_needed: false,
            is_online_payment_mandatory: false,
            need_online_payment: false,
            thawani_data_id: "",
            enrollData: [],
            selected_price: 20000,
            show_payment_details: false,
            auction_details: {},
            open_popup: false,
            file_receipt: null,
            is_not_wallet_balance: false,
            is_profile_completed: true,
            wallet_amount: 0,
            is_blacklisted: false,
            missingField: [],

            showProfileUpdate: true,
            is_profile_completed: true,
            is_blacklisted: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handlePayment = this.handlePayment.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.saveEnroll = this.saveEnroll.bind(this);
        this.createCustomer = this.createCustomer.bind(this);
        this.gotoPayment = this.gotoPayment.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }





    componentDidMount() {
        window.scrollTo(0, 0);

        let { input } = this.state;
        let fieldsToCheck = [
            "account_number",
            "resident_card_number",
            "file_id_number",
        ];
        if (input.is_company) {
            fieldsToCheck = [
                "authority_name",
                "account_number",
                "cr_number",
                "resident_card_number",
                "vat_number",
                "file_id_number",
                "file_cr_number",
                "file_auth_letter",
                "file_vat_certificate",
            ];
        }

        let missingField = [];
        fieldsToCheck.forEach((field) => {
            if (
                input[field] === "" ||
                input[field] === null ||
                input[field] === false
            ) {
                this.setState({ is_profile_completed: false });
                missingField.push(field);
            }
        });
        console.log(missingField);
        this.setState({ missingField: missingField });

        this.loadAuction();
        this.checkUserWallet();
        this.checkBlacklist();
        this.checkUserStatus();

    }

    async checkBlacklist() {
        const response = await checkBlackList();
        if (response.success) {
            let { data } = response;
            this.setState({ is_blacklisted: data.is_blacklisted });
        }
    }
    async loadAuction() {
        let id = this.state.auction;
        const response = await getAuction(id);
        if (response) {
            let auction = response.data;
            this.setState({ auction_details: auction });
            let payment_needed = false;
            if (
                auction.payment_type === "Online" ||
                auction.payment_type === "Both"
            ) {
                payment_needed = true;
                if (auction.payment_type === "Online") {
                    this.setState({
                        is_online_payment_mandatory: true,
                        show_payment_details: true,
                        need_online_payment: true,
                    });
                }
                if (auction.payment_amount) {
                    let paymentAmount = auction.payment_amount * 1000;
                    this.setState({
                        selected_price: paymentAmount,
                    });
                }
            }
            this.setState({
                terms: auction.terms,
                terms_ar: auction.terms_arabic,
                is_online_payment_needed: payment_needed,
            });
        }
    }

    checkUserStatus = async () => {
        try {
            const statusResponse = await getUserStatus();

            if (statusResponse?.code === 403) {
                this.setState({ showProfileUpdate: true });
                return;
            }

            if (statusResponse?.code === 404) {
                swal("Failed", "You are blocked from bidding.", "error");
                return;
            }

            if (statusResponse?.code === 200 || statusResponse?.success === true) {
                this.setState({ showProfileUpdate: false });
                return;
            }

            // If we get here, the response structure might be different
            console.log("Unexpected response structure:", statusResponse);

        } catch (error) {
            console.error("Error checking user status:", error);
            swal("Failed", "Unable to verify user status.", "error");
        }
    };




    handleChange(event) {
        let input = this.state.input;
        input[event.target.name] = event.target.value;
        this.setState({ input });
    }

    handlePayment(event) {
        let payment = this.state.payment;
        payment[event.target.name] = event.target.value;
        this.setState({ payment });
    }

    onFileChange = (event) => {
        console.log(event);
        console.log("Selected file Parent:", event.target.files[0]);
        if (!this.validateFileSize(event.target.files[0])) {
            swal("Failed", "File size should be less than 5MB", "error");
            return;
        }

        if (event.target.name === "file_receipt") {
            this.setState({ file_receipt: event.target.files[0] });
        }
    };

    validateFileSize(file) {
        const MAX_FILE_SIZE = 5120; // 5MB
        const fileSizeKiloBytes = file.size / 1024;
        if (fileSizeKiloBytes > MAX_FILE_SIZE) {
            return;
        }
        return true;
    }

    async saveEnroll(event) {
        event.preventDefault();
        //Validation
        let { bank, account_number, beneficiary, receipt_number } = this.state.input;
        if (this.state.ptype === "offline") {
            if (
                !bank ||
                bank === "null" ||
                !account_number ||
                account_number === "null" ||
                !beneficiary ||
                beneficiary === "null" ||
                !receipt_number ||
                receipt_number === "null" ||
                this.state.file_receipt === null
            ) {
                swal(i18n.t("failed"), i18n.t("all_mandatory"), "error");
                return;
            }
        }

        let { auction_details } = this.state;
        this.setState({ is_loading: true });
        let amount = auction_details.payment_amount;
        if (this.state.ptype === "online") {
            let { online_type } = this.state;
            let two_percent = (parseFloat(amount) * 2) / 100;
            let credit_amount = parseFloat(amount) + parseFloat(two_percent);

            let one_five_percent = (parseFloat(amount) * 1.5) / 100;
            let debit_amount = parseFloat(amount) + parseFloat(one_five_percent);
            if (online_type === "local") {
                amount = debit_amount;
            }
            if (online_type === "credit") {
                amount = credit_amount;
            }
        }
        this.setState({
            selected_price: amount * 1000,
        });
        const formData = new FormData();
        formData.append("auction", this.state.auction);
        formData.append("enroll_name", this.state.input.name);
        formData.append("identity_type", this.state.input.identity_type);

        formData.append("bank", this.state.input.bank);
        formData.append("account_number", this.state.input.account_number);
        formData.append("beneficiary", this.state.input.beneficiary);
        formData.append("receipt_number", this.state.input.receipt_number);

        formData.append("is_company", this.state.is_company ? true : false);
        formData.append("is_offline", !this.state.need_online_payment);
        formData.append("ptype", this.state.ptype);
        formData.append("identity_type", "Civil Card");
        formData.append("amount", auction_details.payment_amount);
        // formData.forEach((value, key) => {
        //   console.log(`${key}:`, value);
        // });
        // return;
        if (this.state.file_receipt) {
            formData.append(
                "file_receipt",
                this.state.file_receipt,
                this.state.file_receipt.name
            );
        }

        this.setState({ is_payment_loading: true });
        const response = await enrollUser(formData);
        if (response.success) {
            this.setState({ show_success_message: true });
            this.setState({ is_loading: false });
            this.setState({ is_payment_loading: false });
            if (this.state.ptype === "online") {
                this.setState({ show_success_message: false });
                this.handlePay(response.data);
                this.setState({ is_payment: true, enrollData: response.data });
            }
        } else {
            this.setState({ is_loading: false });
            this.setState({ is_payment_loading: false });
            swal("Failed", response.message, "error");
            return;
        }
    }

    async gotoPayment() {
        let enroll = this.state.enrollData;
        let customer_id = this.state.thawani_data_id;
        let queryParams = `?gid=${enroll.group_id}&eid=${enroll.id}&auc=${this.state.auction
            }&amt=${Number(this.state.selected_price) / 1000}`;
        let payload = {
            client_reference_id: user.email,
            mode: "payment",
            products: [
                {
                    name: "Mzadcom Auction",
                    quantity: 1,
                    unit_amount: parseInt(this.state.selected_price),
                },
            ],
            success_url: paymentSuccessUrl + queryParams,
            cancel_url: paymentCancelledUrl + queryParams,
            customer_id: customer_id,
            metadata: {
                "Customer name": user.name,
                "Order id": enroll.id,
                user: user.id,
                auction: this.state.auction,
            },
        };

        let thw = await createThawaniSession(payload);
        this.setState({ is_payment_loading: false });

        if (thw && thw.data && thw.success && thw.data.session_id) {
            let session_id = thw.data.session_id;
            localStorage.setItem("invoice", thw.data.invoice);
            window.location.href =
                thawaniPaymentUrl +
                session_id +
                "?key=" +
                thawaniConfig.publishable_key;
        }
    }

    async createCustomer(enroll) {
        window.scrollTo(0, 0);
        if (user && (user.email || user.username)) {
            let thw = await createThawaniCustomer({
                client_customer_id: user.email ? user.email : user.username,
            });
            if (thw && thw.data) {
                localStorage.setItem("thawani_customer_id", thw.data.id);
                this.setState({ thawani_data_id: thw.data.id });
                this.gotoPayment();
            }
        }
    }

    closeModal() {
        this.setState({ open_popup: false });
    }

    openModal() {
        this.setState({ open_popup: true });
    }

    async handlePay(res) {
        let { auction_details } = this.state;
        // let {group_id , auction , } = res;
        this.setState({ is_loading: true });
        let amount = auction_details.payment_amount;
        let og_amount = auction_details.payment_amount;
        if (this.state.ptype === "online") {
            let { online_type } = this.state;
            let two_percent = (parseFloat(amount) * 2) / 100;
            let credit_amount = parseFloat(amount) + parseFloat(two_percent);

            let one_five_percent = (parseFloat(amount) * 1.5) / 100;
            let debit_amount = parseFloat(amount) + parseFloat(one_five_percent);
            if (online_type === "local") {
                amount = debit_amount;
            }
            if (online_type === "credit") {
                amount = credit_amount;
            }
        }
        const data = {
            amount,
            currency: "SAR",
            description: "Test Data",
            type: "enroll",
            group_id: res.group_id,
            auction: res.aution,
            enroll_id: res.id,
            og_amount: og_amount
        }

        const response = await createPayment(data);
        window.location.href = response.data.redirect_url;
        // redirect to EdfaPay
        this.setState({ is_loading: false });
    };

    async checkUserWallet() {
        const response = await getUserInfo(user.id);
        if (response && response.success) {
            let usr = response.data;
            if (usr) {
                user.wallet_amount = usr.wallet_amount;
                localStorage.setItem("mzad_user_info", JSON.stringify(user));
                this.setState({ wallet_amount: usr.wallet_amount });
                if (
                    Number(usr.wallet_amount) === 0 ||
                    Number(usr.wallet_amount) <
                    Number(this.state.auction_details.payment_amount)
                ) {
                    this.setState({ is_not_wallet_balance: true });
                }
            }
        }
    }

    componentDidCatch(error, errorInfo) {
        console.error("Enrollment Error:", error, errorInfo);
        this.setState({ hasError: true });
    }



    render() {
        const {
            ptype,
            online_type,
            show_terms_panel,
            show_bank_panel,
            t_c_accept,
            input,
            file_receipt,
            is_loading,
            auction_details,
            wallet_amount,
            is_profile_completed,
            is_blacklisted,
            is_not_wallet_balance,
            show_wallet_fund_screen,
            show_success_message,
            showProfileUpdate,
            is_company
        } = this.state;

        const payment_amount = auction_details.payment_amount || 0;
        const two_percent = (payment_amount * 2) / 100;
        const credit_amount = payment_amount + two_percent;
        const one_five_percent = (payment_amount * 1.5) / 100;
        const debit_amount = payment_amount + one_five_percent;

        const is_paynow_disable = !t_c_accept || is_loading || !is_profile_completed || (ptype === "wallet" && is_not_wallet_balance) || is_blacklisted;

        return (
            <div className='modern-page'>
                <HomeBanner callbackForSupport={this.props.callbackForSupport} />
                <div className="modern-enroll main-content">

                    <div className="container">
                        <div className="row" style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
                            <div style={{ flex: '2', minWidth: '300px' }}>
                                <div className="main-card">
                                    <div className="card-header">
                                        <h1 className="card-title">
                                            <Gavel size={24} />
                                            {auction_details.title}
                                        </h1>
                                    </div>



                                    <div className="card-body">

                                        {showProfileUpdate && (
                                            <ProfileUpdateSection
                                                user={input}
                                                onClose={() => this.setState({ showProfileUpdate: false })}
                                                onSuccess={(message) => this.handleProfileSuccess(message)}
                                                onError={(message) => this.handleProfileError(message)}
                                                is_loading={is_loading}
                                                checkUserStatus={this.checkUserStatus}
                                            />
                                        )}

                                        {!showProfileUpdate && (<div>
                                            {is_blacklisted && (
                                                <div className="alert alert-danger">
                                                    <AlertCircle size={20} />
                                                    {i18n.t("user_blacklisted_message")}
                                                </div>
                                            )}

                                            {!is_profile_completed && (
                                                <div className="alert alert-warning">
                                                    <AlertCircle size={20} />
                                                    <div>
                                                        <div>{i18n.t("profile_completion_message")}</div>
                                                        <button
                                                            style={{
                                                                background: 'rgba(255,255,255,0.2)',
                                                                border: '1px solid rgba(255,255,255,0.3)',
                                                                color: 'white',
                                                                padding: '0.5rem 1rem',
                                                                borderRadius: '8px',
                                                                marginTop: '0.5rem',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            {i18n.t("profile")}
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {auction_details.is_enrolled && (
                                                <div className="alert alert-success">
                                                    <CheckCircle size={20} />
                                                    {i18n.t("enrolled_message")}
                                                </div>
                                            )}

                                            <div className="payment-section">
                                                <div className="section-header">
                                                    <div className="section-title">
                                                        <Wallet size={20} />
                                                        {i18n.t("pay_type")}
                                                    </div>
                                                    <div className="amount-display">
                                                        {i18n.t("enroll_amount")}: {payment_amount} <SaudiRiyal />
                                                    </div>
                                                </div>

                                                <div className="payment-buttons">
                                                    <div
                                                        className={`payment-btn ${ptype === 'offline' ? 'active' : ''}`}
                                                        onClick={() => this.setState({
                                                            ptype: 'offline',
                                                            show_wallet_fund_screen: false
                                                        })}
                                                    >
                                                        <Building2 size={20} />
                                                        {i18n.t("bank_transfer")}
                                                    </div>

                                                    <div
                                                        className={`payment-btn ${ptype === 'online' ? 'active' : ''}`}
                                                        onClick={() => this.setState({
                                                            ptype: 'online',
                                                            show_wallet_fund_screen: false
                                                        })}
                                                    >
                                                        <CreditCard size={20} />
                                                        {i18n.t("online")}
                                                    </div>

                                                    <div
                                                        className={`payment-btn ${ptype === 'wallet' ? 'active' : ''}`}
                                                        onClick={() => this.setState({
                                                            ptype: 'wallet',
                                                            show_wallet_fund_screen: false
                                                        })}
                                                    >
                                                        <Wallet size={20} />
                                                        {i18n.t("wallet")}
                                                    </div>
                                                </div>
                                            </div>

                                            {ptype === 'offline' && (
                                                <div>
                                                    <div className="policy-section">
                                                        <h3 style={{ marginBottom: '1rem', color: '#2c3e50' }}>
                                                            {i18n.t("guarantee_amount_policy_head")}
                                                        </h3>
                                                        <div className="policy-content">
                                                            <p>1) Those willing to participate in the e-auction must deposit a Guarantee amount.</p>
                                                            <p>2) The Guarantee amount is refundable. However, the Service Charges for the Online Payment is not refundable.</p>
                                                            <p>3) The guarantee amount is separate from the value of the items offered in the auction.</p>
                                                            <p>4) The Guarantee amount may vary from item to item.</p>
                                                            <p>5) The Guarantee amount is not automatically returned. In case of delay, Mzadcom will not bear any delay in refund.</p>
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <div className="form-group">
                                                                <label className="form-label">
                                                                    * {i18n.t("bank")}
                                                                </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="bank"
                                                                    placeholder="Enter bank name"
                                                                    value={input.bank}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="form-group">
                                                                <label className="form-label">
                                                                    * {i18n.t("account_number")}
                                                                </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="account_number"
                                                                    placeholder="Enter account number"
                                                                    value={input.account_number}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="form-group">
                                                                <label className="form-label">
                                                                    * {i18n.t("beneficiary")}
                                                                </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="beneficiary"
                                                                    placeholder="Enter beneficiary name"
                                                                    value={input.beneficiary}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="form-group">
                                                                <label className="form-label">
                                                                    * {i18n.t("receipt")}
                                                                </label>
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="receipt_number"
                                                                    placeholder="Enter receipt number"
                                                                    value={input.receipt_number}
                                                                    onChange={this.handleChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <div className="form-group">
                                                                <label className="form-label">
                                                                    * Receipt File
                                                                </label>
                                                                <div className="file-input-container">
                                                                    <input
                                                                        type="file"
                                                                        className="file-input"
                                                                        name="file_receipt"
                                                                        onChange={this.onFileChange}
                                                                    />
                                                                    <div className={`file-input-display ${file_receipt ? 'has-file' : ''}`}>
                                                                        <Upload size={20} />
                                                                        <span>
                                                                            {file_receipt ? file_receipt.name : 'Choose receipt file'}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>


                                                </div>
                                            )}

                                            {ptype === 'online' && (
                                                <div>
                                                    <div className="policy-section">
                                                        <h3 style={{ marginBottom: '1rem', color: '#2c3e50' }}>
                                                            Online Payment Policy
                                                        </h3>
                                                        <div className="policy-content">
                                                            <p>1) Service charges apply for online payments.</p>
                                                            <p>2) 1.5% for local/debit cards, 2% for credit cards.</p>
                                                            <p>3) Service charges are non-refundable.</p>
                                                            <p>4) You will be redirected to EDFA Payment Gateway.</p>
                                                        </div>
                                                    </div>

                                                    <div style={{ textAlign: 'center', margin: '1.5rem 0' }}>
                                                        <p style={{ color: '#666', marginBottom: '1rem' }}>
                                                            {i18n.t("redirect_to_payment")}
                                                        </p>
                                                    </div>

                                                    <div className="online-payment-options">
                                                        <div
                                                            className={`online-option ${online_type === 'local' ? 'active' : ''}`}
                                                            onClick={() => this.setState({ online_type: 'local' })}
                                                        >
                                                            <div>Local Cards</div>
                                                            <div style={{ fontSize: '0.9rem', opacity: 0.8 }}>
                                                                {/* {debit_amount.toFixed(2)} <SaudiRiyal/> (1.5%) */}
                                                            </div>
                                                        </div>

                                                        <div
                                                            className={`online-option ${online_type === 'credit' ? 'active' : ''}`}
                                                            onClick={() => this.setState({ online_type: 'credit' })}
                                                        >
                                                            <div>Credit Cards</div>
                                                            <div style={{ fontSize: '0.9rem', opacity: 0.8 }}>
                                                                {/* {credit_amount.toFixed(2)} <SaudiRiyal/> (2%) */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {ptype === 'wallet' && (
                                                <div>
                                                    <div className="wallet-balance">
                                                        <Wallet size={20} />
                                                        {i18n.t("balance")}: {wallet_amount} <SaudiRiyal />
                                                    </div>

                                                    {is_not_wallet_balance && (
                                                        <div className="alert alert-warning">
                                                            <AlertCircle size={20} />
                                                            <div>
                                                                <div>{i18n.t("insufficient_wallet_balance")}</div>
                                                                <button
                                                                    style={{
                                                                        background: 'rgba(255,255,255,0.2)',
                                                                        border: '1px solid rgba(255,255,255,0.3)',
                                                                        color: 'white',
                                                                        padding: '0.5rem 1rem',
                                                                        borderRadius: '8px',
                                                                        marginTop: '0.5rem',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    onClick={() => this.setState({
                                                                        show_wallet_fund_screen: !show_wallet_fund_screen
                                                                    })}
                                                                >
                                                                    {i18n.t("add_fund")}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {this.state.show_wallet_fund_screen && (
                                                <div className="mt-3">
                                                    <WalletFund />
                                                </div>
                                            )}

                                            <div className="checkbox-container">
                                                <div
                                                    className={`custom-checkbox ${t_c_accept ? 'checked' : ''}`}
                                                    onClick={() => this.setState({ t_c_accept: !t_c_accept })}
                                                />
                                                <span>{i18n.t("agree_to_terms")}</span>
                                            </div>

                                            <button
                                                type="button"
                                                className="submit-btn"
                                                onClick={this.saveEnroll}
                                                disabled={is_paynow_disable}
                                            >
                                                {is_loading ? (
                                                    <>
                                                        <Loader2 size={20} className="loading-spinner" />
                                                        Loading...
                                                    </>
                                                ) : (
                                                    <>
                                                        <CreditCard size={20} />
                                                        {i18n.t("save_continue")}
                                                    </>
                                                )}
                                            </button>

                                            {show_success_message && (
                                                <div className="success-message">
                                                    <CheckCircle size={24} style={{ marginBottom: '0.5rem' }} />
                                                    <div>Enrollment completed successfully!</div>
                                                </div>
                                            )}
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>


                            <div style={{ flex: '1', minWidth: '300px' }}>
                                <div className="sidebar-card">
                                    <div
                                        className="sidebar-header"
                                        onClick={() => this.setState({ show_terms_panel: !show_terms_panel })}
                                    >
                                        <div className="sidebar-title">
                                            <FileText size={20} />
                                            {i18n.t("terms_conditions")}
                                        </div>
                                        {show_terms_panel ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                    </div>
                                    {show_terms_panel && (
                                        <div className="sidebar-content">
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                background: '#f8f9fa',
                                                padding: '1rem',
                                                borderRadius: '8px',
                                                border: '1px solid #e1e8ed'
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                                                    <div style={{ color: '#dc3545', fontSize: '1.5rem' }}>📄</div>
                                                    <span>{i18n.t("download_attatchment")}</span>
                                                </div>
                                                <button
                                                    style={{
                                                        background: 'linear-gradient(135deg, #189397, #4fc1c0)',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '0.5rem 1rem',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '0.5rem',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '600'
                                                    }}
                                                    onClick={() => window.open(auction_details.file_terms, '_blank')}
                                                >
                                                    <Eye size={16} />
                                                    {i18n.t("preview")}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="sidebar-card">
                                    <div
                                        className="sidebar-header"
                                        onClick={() => this.setState({ show_bank_panel: !show_bank_panel })}
                                    >
                                        <div className="sidebar-title">
                                            <Building2 size={20} />
                                            {i18n.t("bank_details")}
                                        </div>
                                        {show_bank_panel ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                    </div>
                                    {show_bank_panel && (
                                        <div className="sidebar-content">
                                            <div className="bank-details">
                                                <div style={{ marginBottom: '0.5rem' }}>
                                                    <strong>Bank Name:</strong> Al Rajhi Bank
                                                </div>
                                                <div style={{ marginBottom: '0.5rem' }}>
                                                    <strong>Account Name:</strong> Mazadcom Smart Company Auction Solutions SOL
                                                </div>
                                                <div style={{ marginBottom: '0.5rem' }}>
                                                    <strong>Account Number:</strong> 465000010006085776030
                                                </div>
                                                <div style={{ marginBottom: '0.5rem' }}>
                                                    <strong>IBAN Number:</strong> SA4480000465608015776030
                                                </div>
                                                <div style={{ marginBottom: '0.5rem' }}>
                                                    <strong>Currency:</strong> SAUDI RIYAL
                                                </div>

                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}